import { NgModule, SecurityContext, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { httpInterceptorProviders } from '../_helpers/http.interceptor';
import { sanitizeGeneratedHtml } from '../_helpers/safe-html';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { MarkdownModule, MARKED_OPTIONS, MARKED_EXTENSIONS, SANITIZE } from 'ngx-markdown';

import markedKatex from 'marked-katex-extension';
import { MatDialogModule } from '@angular/material/dialog';
import { NotificationQueueDirective } from '../_directives/notification-queue.directive';
import { LostpasswordComponent } from './lostpassword/lostpassword.component';
import { FirstLoginComponent } from './first-login/first-login.component';

import { ConfigService } from '../_services/config.service';
import { firstValueFrom } from 'rxjs';
import { IsDeconnectdComponent } from './is-deconnectd/is-deconnectd.component';

export function initConfig(cfg: ConfigService) {
  return () => firstValueFrom(cfg.loadConfig());
}

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        NotificationQueueDirective,
        LostpasswordComponent,
        FirstLoginComponent,
        IsDeconnectdComponent,
    ],
    exports: [],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MarkdownModule.forRoot({
            markedOptions: {
                provide: MARKED_OPTIONS,
                useValue: {
                    gfm: true,
                    breaks: false,
                },
            },
            // `markedExtensions` attend des providers multi sur MARKED_EXTENSIONS,
            // et non les extensions brutes : jusqu'à ngx-markdown 17 la forme
            // directe passait, depuis la v18 elle fait échouer le démarrage avec
            // « Invalid provider for the NgModule 'MarkdownModule' ». Le cast en
            // `any` masquait l'écart à la compilation (cf. app.module.spec.ts).
            markedExtensions: [
                {
                    provide: MARKED_EXTENSIONS,
                    useValue: markedKatex({
                        throwOnError: false,
                        output: 'html',
                    }),
                    multi: true,
                },
            ],
            // Sans cette entrée, ngx-markdown ne passe le rendu qu'au nettoyage
            // générique d'Angular. Le nettoyage dédié passe d'abord ; celui
            // d'Angular reste en seconde ligne, le rendu ne change donc pas.
            sanitize: {
                provide: SANITIZE,
                useFactory: () => {
                    const sanitizer = inject(DomSanitizer);
                    return (html: string) =>
                        sanitizer.sanitize(SecurityContext.HTML, sanitizeGeneratedHtml(html)) ?? '';
                },
            },
        })], providers: [
        //    httpInterceptorProviders
        ConfigService,
        provideAppInitializer(() => {
        const initializerFn = (initConfig)(inject(ConfigService));
        return initializerFn();
      }),
        httpInterceptorProviders,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
